import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs/operators';
import { Company } from 'src/app/domains/companies/models';
import { CompanyService } from 'src/app/domains/companies/services';
import { Review } from 'voxloud-types/dist/models/reviews';
import { ReviewsService } from 'src/app/domains/reviews/services';

@Component({
  selector: 'gdp-update-review-popup',
  templateUrl: './update-review-popup.component.html',
  styleUrls: ['./update-review-popup.component.scss']
})
export class UpdateReviewPopupComponent implements OnInit {
  public review: Review;
  public company: Company | null;
  public loading: boolean = false;
  public companyFormControl: UntypedFormControl;
  @Output() onAssigntoCompany: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private activeModal: NgbActiveModal,
    private reviewsService: ReviewsService,
    private companyService: CompanyService
  ) { }

  ngOnInit(): void {
    if (this.review.company_id) {
      this.fetchCompany(this.review.company_id);
    }
    else this.companyFormControl = new UntypedFormControl(null);
  }

  public assignCompany() {
    let companyId = this.companyFormControl.value ? this.companyFormControl.value.companyId : null;
    this.loading = true;
    this.reviewsService.updateReview({ ...this.review, company_id: companyId }).subscribe(
      (response: Review) => {
        this.onAssigntoCompany.emit();
        this.loading = false;
        this.close();
      }, () => {
        this.loading = false;
        this.close();
      });
  }

  public fetchCompany(id: number) {
    this.companyService
      .getCompany(id)
      .pipe(take(1))
      .subscribe(
        (c: Company) => {
          this.company = c;
          this.companyFormControl = new UntypedFormControl(this.company);
        },
        () => {
          this.company = null;
        }
      );
  }

  close() {
    this.activeModal.close();
  }
}
